export enum EInputSize {
    SM = 'sm',
    DEFAULT = 'default',
    LG = 'lg',
}